import axios from 'axios'
import * as types from '../mutation-types'

export const state = {
  courses: [],
  reservations: [],
  registered_courses: [],
  course_in_register: {},
  students: [],
  student_in_register: {},
  loading: false,
  registered_courses_saved: [],
  payment_data_type: [],
  payment_data_course: [],
  payment_data_type_ext: [],
  payment_data_course_ext: [],
}

export const actions = {
  fetchStudents ({ commit, state }) {
    axios.get('/api/extracurriculares/registration/students')
      .then(resp => {
        if (resp.status === 200) {
          commit(types.SET_STUDENTS, resp.data.students)
          const studentInRegister = resp.data.students.find(student => student.id === state.student_in_register.id)
          if (studentInRegister) {
            commit(types.SET_STUDENT_IN_REGISTER, studentInRegister)
          }
        }
      })
      .catch(() => {

      })
  },
  fetchReservations ({ commit }) {
    commit(types.SET_LOADING, true)
    axios.get('/api/extracurriculares/registration/reserved')
      .then(resp => {
        if (resp.status === 200) {
          commit(types.SET_RESERVATIONS, resp.data.reservations)
          commit(types.SET_LOADING, false)
        }
      })
      .catch(error => {
        console.log(error)
        commit(types.SET_LOADING, false)
      })
  },
  fetchRegisteredCourses ({ commit, state }) {
    return axios.get('/api/extracurriculares/course/registered')
      .then(resp => {
        if (resp.status === 200) {
          commit(types.SET_REGISTERED_COURSES_SAVED, resp.data)
          const courses = resp.data.find(register => register.student_id === state.student_in_register.id)
          .enrolled_courses
          .map(course => course.course_id)
          let coursesToAdd = courses
          state.registered_courses.forEach(courseToAdd => {
            if (!coursesToAdd.includes(courseToAdd)) {
              coursesToAdd.push(courseToAdd)
            }
          });

          if (courses.length > 0) {
            commit(types.SET_REGISTERED_COURSES, coursesToAdd)
          }
        }
      })
      .catch(error => {

      })
  },
  fetchPaymentData ({ commit }) {
    commit(types.SET_LOADING, true)
    axios.get(`/api/extracurriculares/registration/payment_data`)
      .then(resp => {
        if (resp.status === 200) {
          commit(types.SET_PAYMENT_DATA, resp.data)
        }
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        commit(types.SET_LOADING, false)
      })
  },
  fetchExtRegisteredCourses ({ commit, state }) {
    return axios.get('/api/external/extracurriculares/course/registered')
      .then(resp => {
        if (resp.status === 200) {
          commit(types.SET_REGISTERED_COURSES_SAVED, resp.data)
          const courses = resp.data.find(register => register.student_id === state.student_in_register.id)
          .enrolled_courses
          .map(course => course.course_id)
          let coursesToAdd = courses
          state.registered_courses.forEach(courseToAdd => {
            if (!coursesToAdd.includes(courseToAdd)) {
              coursesToAdd.push(courseToAdd)
            }
          });

          if (courses.length > 0) {
            commit(types.SET_REGISTERED_COURSES, coursesToAdd)
          }
        }
      })
      .catch(error => {

      })
  },
  fetchExtPaymentData ({ commit }) {
    commit(types.SET_LOADING, true)
    axios.get(`/api/external/extracurriculares/registration/payment_data`)
      .then(resp => {
        if (resp.status === 200) {
          commit(types.SET_PAYMENT_DATA, resp.data)
        }
        commit(types.SET_LOADING, false)
      })
      .catch(error => {
        commit(types.SET_LOADING, false)
      })
  }
}

export const mutations = {
  [types.SET_COURSES] (state, courses) {
    state.courses = courses
  },
  [types.SET_RESERVATIONS] (state, reservations) {
    state.reservations = reservations
  },
  [types.SET_REGISTERED_COURSES] (state, registered_courses) {
    state.registered_courses = registered_courses
  },
  [types.SET_STUDENTS] (state, students) {
    state.students = students
  },
  [types.SET_STUDENT_IN_REGISTER] (state, student) {
    state.student_in_register = student
  },
  [types.SET_LOADING] (state, loading_status) {
    state.loading = loading_status
  },
  [types.SET_REGISTERED_COURSES_SAVED] (state, registered_courses) {
    state.registered_courses_saved = registered_courses
  },
  [types.SET_PAYMENT_DATA] (state, { payment_data_type, payment_data_course, payment_data_type_ext, payment_data_course_ext }) {
    state.payment_data_course = payment_data_course
    state.payment_data_type = payment_data_type
    state.payment_data_course_ext = payment_data_course_ext
    state.payment_data_type_ext = payment_data_type_ext
  }
}

export const getters = {
  courses: state => state.courses,
  reservations: state => state.reservations,
  registeredCourses: state => state.registered_courses,
  students: state => state.students,
  studentInRegister: state => state.student_in_register,
  loading: state => state.loading,
  registeredCoursesSaved: state => state.registered_courses_saved,
  paymentDataCourse: state => state.payment_data_course,
  paymentDataType: state => state.payment_data_type,
  paymentDataCourse_ext: state => state.payment_data_course_ext,
  paymentDataType_ext: state => state.payment_data_type_ext,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/extracurriculares_register.js